import Item from './Item';

export default {
  components: {
    Item
  },
  props: {
    tags: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: '',
      label: '',
      select: null,
      placeholder: 'Add Smartbox Text',
      iconSize: 5
    };
  },
  methods: {
    onClear() {
      this.$emit('addTag', this.search);
    }
  }
};
